export const SET_REFERENCES = "SET_REFERENCES";
export const SET_CURRENT_REFERENCE = "SET_CURRENT_REFERENCE";
export const SET_IS_FETCHING_REFERENCES = "SET_FETCHING_REFERENCES";
export const SET_IS_FETCHING_CURRENT_REFERENCE =
  "SET_IS_FETCHING_CURRENT_REFERENCE";
export const SET_IS_FETCHING_USER_REFERENCES =
  "SET_IS_FETCHING_USER_REFERENCES";
export const SET_CURRENT_USER_REFERENCES = "SET_CURRENT_USER_REFERENCES";

import { setStoreValue } from "@/store/utils";

const mutations = {
  [SET_REFERENCES]: setStoreValue("references"),
  [SET_CURRENT_REFERENCE]: setStoreValue("currentReference"),
  [SET_IS_FETCHING_REFERENCES]: setStoreValue("isFetchingReferences"),
  [SET_IS_FETCHING_CURRENT_REFERENCE]: setStoreValue(
    "isFetchingCurrentReference"
  ),
  [SET_CURRENT_USER_REFERENCES]: setStoreValue("currentUserReferences"),
  [SET_IS_FETCHING_USER_REFERENCES]: setStoreValue("isFetchingUserReferences")
};

export default mutations;
